import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetInventory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path d="M2.9 4.115a1 1 0 0 1 1-1h12.167a1 1 0 0 1 1 1v1.042a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1zm0 5.07a1 1 0 0 1 1-1h5.084a1 1 0 0 1 1 1v1.042a1 1 0 0 1-1 1H3.9a1 1 0 0 1-1-1zm0 5.57a1.5 1.5 0 0 1 1.5-1.5h4.084a1.5 1.5 0 0 1 1.5 1.5v1.056a1.5 1.5 0 0 1-1.5 1.5H4.4a1.5 1.5 0 0 1-1.5-1.5zm9.108-5.07a1.5 1.5 0 0 1 1.5-1.5h2.06a1.5 1.5 0 0 1 1.5 1.5v6.126a1.5 1.5 0 0 1-1.5 1.5h-2.06a1.5 1.5 0 0 1-1.5-1.5z" />
  </svg>
);
export default SvgAssetInventory;
